import {registerLocaleData} from '@angular/common'
import {provideHttpClient, withInterceptors} from '@angular/common/http'
import localeFr from '@angular/common/locales/fr'
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core'
import {
  LuxonDateAdapter,
  MAT_LUXON_DATE_ADAPTER_OPTIONS,
  MAT_LUXON_DATE_FORMATS
} from '@angular/material-luxon-adapter'
import {MAT_CARD_CONFIG} from '@angular/material/card'
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {MatPaginatorIntl} from '@angular/material/paginator'
import {
  provideRouter,
  withHashLocation,
  withInMemoryScrolling
} from '@angular/router'
import {
  authInterceptor,
  ConfigService,
  IConfig,
  responseInterceptor,
  SPB_LOGIN_SETTINGS,
  SPS_CONFIG
} from '@sparbanken-syd/sparbanken-syd-bankid'
import {SpbPaginatorSv} from '@sparbanken-syd/sparbanken-syd-theme'
import {environment} from '../environments/environment'
import {routes} from './app.routes'
import {WINDOW} from './application/app'
import {
  BASE_PATH,
  CREDIT_ROLE,
  CUSTOMER_SUPPORT_ROLE, FM_ADMIN_ROLE,
  INTERNAL_SUPPORT_ROLE,
  WATCH_ROLE
} from './services/types'


registerLocaleData(localeFr, 'fr')

const configServiceConfig: IConfig = {
  authServiceUrl: environment.userServiceUrl,
  domain: environment.domain,
  adminRoles: [CUSTOMER_SUPPORT_ROLE, INTERNAL_SUPPORT_ROLE, WATCH_ROLE, CREDIT_ROLE, FM_ADMIN_ROLE]
}

export const appConfig: ApplicationConfig = {
  providers: [
    {provide: SPS_CONFIG, useValue: configServiceConfig},
    {
      provide: SPB_LOGIN_SETTINGS, useValue: {
        text: 'För att komma igång behöver du först logga in med ditt BankID',
        buttonText: 'Logga in med BankID',
        route: ['/', BASE_PATH]
      }
    },
    provideAppInitializer(() => inject(ConfigService).bootstrap()),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        floatLabel: 'always',
        hideRequiredMarker: true,
        appearance: 'outline'
      }
    },
    {provide: WINDOW, useValue: window},
    {provide: MAT_DATE_LOCALE, useValue: 'sv-SE'},
    {provide: MAT_CARD_CONFIG, useValue: {appearance: 'outlined'}},
    {
      provide: DateAdapter,
      useClass: LuxonDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_LUXON_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_DATE_FORMATS},
    {provide: MatPaginatorIntl, useClass: SpbPaginatorSv},
    {
      provide: MAT_LUXON_DATE_ADAPTER_OPTIONS,
      useValue: {useUtc: true, firstDayOfWeek: 1}
    },
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes, withHashLocation(), withInMemoryScrolling({anchorScrolling: 'enabled'})),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        responseInterceptor
      ])
    )
  ]
}